import {useMutation} from '@tanstack/react-query';
import {
	PatchCommunication,
	PatchCommunicationParams,
} from 'domain/usecases/private/communications/patch-communication';
import {useConfirmCommunicationHasErrorStore} from '../../store/useConfirmCommunicationHasErrorStore';
import {patchCommunication} from '../../services/patchCommunication';
import {UseConfirmCommunicationMutationOptions} from './types';

export const useConfirmCommunicationMutation = (
	patchCommunicationFactory: PatchCommunication,
	{onSuccess}: UseConfirmCommunicationMutationOptions = {},
) => {
	const setConfirmCommunicationHasError = useConfirmCommunicationHasErrorStore(
		state => state.setConfirmCommunicationHasError,
	);

	return useMutation({
		mutationFn: (params: PatchCommunicationParams) =>
			patchCommunication(patchCommunicationFactory).perform(params),
		onSuccess: async () => {
			onSuccess?.();
		},
		onError: () => {
			setConfirmCommunicationHasError(true);
		},
	});
};
